// import ReactDOM from "react-dom/client";
// import "./index.css";
// import App from "./App";
// import reportWebVitals from "./reportWebVitals";
// import { BrowserRouter } from "react-router-dom";
// import { ChakraProvider } from "@chakra-ui/react";
// import theme from "./utils/theme";
// import store from "./app/store";
// import { Provider } from "react-redux";
// import { getDomainName } from "../src/utils/utils";


// const domain = getDomainName(window.location.href);
// localStorage.setItem("domainName", domain);
// const prefix = process.env.REACT_APP_PREFIX || '';
// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   // <React.StrictMode>
//   <ChakraProvider theme={theme}>
//     <Provider store={store}>
//       <BrowserRouter basename={prefix} >
//         <App />
//       </BrowserRouter>
//     </Provider>
//   </ChakraProvider>
//   // </React.StrictMode>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { ChakraProvider } from "@chakra-ui/react";
import theme from "./utils/theme";
import store from "./app/store";
import { Provider } from "react-redux";
import { getDomainName } from "./utils/utils";
import { WebSocketProvider } from "Context/WebSocketProvider"; // ✅ Import WebSocketProvider

const domain = getDomainName(window.location.href);
localStorage.setItem("domainName", domain);
const prefix = process.env.REACT_APP_PREFIX || '';

const isLoggedIn = !!localStorage.getItem("_m_at"); // ✅ Check if user is logged in

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ChakraProvider theme={theme}>
    <Provider store={store}>
      <BrowserRouter basename={prefix}>
        
          <WebSocketProvider>
            <App />
          </WebSocketProvider>
        
      </BrowserRouter>
    </Provider>
  </ChakraProvider>
);

reportWebVitals();
